import { updateRecommendationDecoration } from './recommendation-decorations';
import { addSelectedRecommendationDecoration, removeSelectedRecommendationDecoration } from './recommendation-selected-decoration';
export var ProactiveDecorations = {
  RECOMMENDATION: 'aiProactiveRecommendation',
  RECOMMENDATION_SELECTED: 'aiProactiveRecommendationSelected'
};
var composeDecorations = function composeDecorations(transformers) {
  return function (_ref) {
    var decorationSet = _ref.decorationSet,
      tr = _ref.tr,
      pluginState = _ref.pluginState;
    return transformers.reduce(function (decorationSet, transform) {
      return transform({
        decorationSet: decorationSet,
        tr: tr,
        pluginState: pluginState
      });
    }, decorationSet);
  };
};
export var filterDecorationByKey = function filterDecorationByKey(key, decorationSet) {
  return decorationSet.find(undefined, undefined, function (spec) {
    return spec.key.indexOf(key) > -1;
  });
};
export var regenerateSelectionDecorations = function regenerateSelectionDecorations(params) {
  return composeDecorations([removeSelectedRecommendationDecoration, addSelectedRecommendationDecoration])(params);
};
export var regenerateAllDecorations = function regenerateAllDecorations(params) {
  return composeDecorations([removeSelectedRecommendationDecoration, updateRecommendationDecoration, addSelectedRecommendationDecoration])(params);
};